import curd from '../curd'

const BASE_PATH = '/role'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/Role.js